import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import moment from 'moment';
import {
  PDFViewer,
  pdf,
  Document,
  Page,
  Text,
  View,
} from '@react-pdf/renderer';

import { config } from '../../../../config/index';

import Modal from '../../../../components/Modal';
import SelfPDFViewer from '../../../../components/PDFViewer';
import AssociateSidebar from '../../../../components/AssociateSidebar';
import ImmediateTermination from '../../../../components/GeneratedLetters/Templates/TerminationLetter/Immediate';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import placeholderImage from '../../../../assets/images/placeholder.jpg';
import { GET, POST, PUT, newFetch } from '../../../../helpers/fetch';

const { SERVER_URL } = config;
const blobToFile = (theBlob, fileName) => {
  //A Blob() is almost a File() - it's just missing the two properties below which we will add
  theBlob.lastModifiedDate = new Date();
  theBlob.name = fileName;
  return theBlob;
};

const TTDetail = ({
  history,
  match: {
    params: { tt_id },
  },
}) => {
  const type = localStorage.getItem('type');

  const [ticket, setTicket] = useState(null);
  const [client, setClient] = useState(null);
  const [incidents, setIncidents] = useState([]);
  const [actions, setActions] = useState([]);
  const [selectedAction, setSelectedAction] = useState(0);

  const [showCloseTicketModal, setShowCloseTicketModal] = useState(false);
  const [resolution, setResolution] = useState('');

  const [showTerminationModal, setShowTerminationModal] = useState(false);
  const [showTerminationLetterModal, setShowTerminationLetterModal] =
    useState(false);
  const [selectedIncident, setSelectedIncident] = useState('');
  const [dateOfIncident, setDateOfIncident] = useState('');
  const [remarks, setRemarks] = useState('');

  const [associate, setAssociate] = useState(null);
  const [showSidebar, setShowSidebar] = useState(null);

  const ImmediateTerminationLetter = (
    <Document author="Manpower" subject="Immediate Termination Letter">
      <Page
        size="A4"
        style={{
          padding: '20px 50px 20px 50px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* <Header /> */}
        <View
          style={{ display: 'flex', flexDirection: 'row', marginBottom: 20 }}
        >
          <View style={{ width: '70%' }}>
            {/* <Image cache={false} src={'https://helpx.adobe.com/content/dam/help/en/stock/how-to/visual-reverse-image-search/jcr_content/main-pars/image/visual-reverse-image-search-v2_intro.jpg'}  /> */}
          </View>
          <View style={{ width: '30%', fontSize: 10, paddingBottom: 4 }}>
            <Text>Manpower</Text>
            <Text>1 Wallich Street</Text>
            <Text>#09-02 Guoco Tower</Text>
            <Text style={{ paddingBottom: 5 }}>Singapore 079903</Text>

            <Text>T: +65 6232 8811</Text>
            <Text>F: +65 6232 8804</Text>
            <Text>www.manpower.com.sg</Text>
          </View>
        </View>
        {/* pnc */}
        <View>
          <Text
            style={{
              fontWeight: 'bold',
              width: '100%',
              fontSize: 13,
              marginBottom: 30,
            }}
          >
            PRIVATE & CONFIDENTIAL
          </Text>
        </View>
        <View style={{ marginBottom: 15 }}>
          {/* date */}
          <Text style={{ marginBottom: 30, fontSize: 11 }}>
            {moment().format('DD MMMM YYYY')}
          </Text>
          {/* associate name */}
          {/* <Text>Bhusham S/O Ramsaran</Text> */}
          {/* associate address */}
          {/* <Text></Text> */}
          {/* dear associate name */}
          {associate && (
            <Text style={{ fontSize: 11 }}>
              Dear {`${associate.first_name} ${associate.last_name}`},
            </Text>
          )}

          {/* title */}
        </View>
        <View style={{ marginBottom: 15 }}>
          <Text
            style={{
              fontWeight: 'bold',
              fontSize: 13,
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            TERMINATION OF CONTRACT
          </Text>
        </View>
        <View style={{ marginBottom: 10 }}>
          <Text style={{ width: '100%', lineHeight: 1.2, fontSize: 11 }}>
            The Company hereby serves you a termination notice with immediate
            effect due to a breach of contract whereby you are{' '}
            {selectedIncident &&
              incidents.find((incident) => incident.id === selectedIncident)
                .name}{' '}
            on{' '}
            {dateOfIncident &&
              moment(dateOfIncident, 'YYYY-MM-DD').format('DD MMMM YYYY')}
            .
          </Text>

          <Text
            style={{
              width: '100%',
              lineHeight: 1.2,
              fontSize: 11,
              paddingTop: 10,
            }}
          >
            {remarks}
          </Text>

          <Text
            style={{
              width: '100%',
              lineHeight: 1.2,
              fontSize: 11,
              paddingTop: 10,
            }}
          >
            In accordance to the Employment Act, you have breached your Contract
            of Service and thus you are required to pay the Company 2 weeks
            salary. You may write a cheque payable to “Manpower Staffing
            Services (Singapore) Pte Ltd or transfer the money to our bank
            account which the details as follow:
          </Text>
        </View>
        <View
          style={{
            flexDirection: 'row',
            width: '100%',
            lineHeight: 1.2,
            marginTop: 14,
            fontSize: 11,
          }}
        >
          <View style={{ width: '30%' }}>
            <Text>Name of Bank Account</Text>
            <Text>Name of Bank</Text>
            <Text>Branch</Text>
            <Text>Bank Number</Text>
            <Text>Bank Account Number</Text>
            <Text>Swift Code</Text>
          </View>
          <View>
            <Text>: Manpower Staffing Services Singapore Pte Ltd</Text>
            <Text>: BNP Paribas Singapore Branch</Text>
            <Text>: Singapore Branch</Text>
            <Text>: 7418</Text>
            <Text>: 04151200181</Text>
            <Text>: BNPASGSG</Text>
          </View>
        </View>
        <View style={{ marginTop: 30 }}>
          <Text style={{ lineHeight: 1.2, fontSize: 11 }}>
            This is a computer generated letter and no signature is required.
          </Text>
        </View>
        {/* <Footer /> */}
      </Page>
    </Document>
  );

  const fetchTicket = async () => {
    let api_path = `/tt/ticket/${tt_id}`;
    let response = await newFetch(GET, api_path);

    response.success && setTicket(response.data);
  };

  const fetchIncidents = async () => {
    let api_path = '/tt/incident';
    let response = await newFetch(GET, api_path);

    response.success && setIncidents(response.data);
  };

  useEffect(() => {
    fetchTicket();
    fetchIncidents();
  }, []);

  useEffect(() => {
    const fetchClient = async () => {
      let api_path = `/client/${ticket.site.client_id}`;
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setClient(response.data);
        setSelectedAction(response.data.action_id);
      }
    };

    const fetchActions = async () => {
      let api_path = `/tt/action`;
      let response = await newFetch(GET, api_path);
      if (response.success && response.data.length > 0) {
        setActions(
          response.data.filter(
            (action) => action.sev_id === ticket.incident.sev_id
          )
        );
      }
    };

    if (ticket) {
      fetchClient();
      fetchActions();
    }
  }, [ticket]);

  const initiateProgressHandler = async () => {
    let api_path = `/tt/ticket/${ticket.id}/initiate_in_progress`;
    let response = await newFetch(PUT, api_path);

    if (response.success) fetchTicket();
  };

  const selectActionHandler = async (e) => {
    let action_id = parseInt(e.target.value);

    if (action_id > 0) {
      setSelectedAction(action_id);
      let data = { action_id };

      let api_path = `/tt/ticket/${ticket.id}/action`;
      let response = await newFetch(PUT, api_path, data);

      if (response.success) fetchTicket();
    }
  };

  const openAssociateSidebar = async (associate_id) => {
    let api_path = `/associate/${associate_id}`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setAssociate(response.data);
      setShowSidebar(true);
    } else {
      ToastUtil.error('Associate is no longer employed.');
    }
  };

  const openTerminationModal = () => {
    setShowTerminationModal(true);
    setShowSidebar(false);
  };

  const closeTerminationModal = () => {
    setAssociate(null);
    setShowTerminationModal(false);
  };

  const previewTerminationLetter = () => {};

  const terminationHandler = async (e) => {
    e.preventDefault();

    if (!associate) {
      ToastUtil.error('Please select associate.');
      return false;
    }

    if (!selectedIncident) {
      ToastUtil.error('Please select incident.');
      return false;
    }

    if (!dateOfIncident) {
      ToastUtil.error('Please select date of incident.');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to terminate this associate?'
      )
    ) {
      const blob = await pdf(ImmediateTerminationLetter).toBlob();
      const pdfFile = new File([blob], `${Date.now()}-${associate.id}.pdf`);

      let formData = new FormData();
      formData.append('file', pdfFile);
      formData.append('associate_id', associate.id);
      formData.append('incident_id', selectedIncident);
      formData.append('date_of_incident', dateOfIncident);
      formData.append('remarks', remarks);

      let api_path = '/associate/terminate';
      let response = await newFetch(POST, api_path, formData, 'form');

      ToastUtil.success(response.message);

      if (response.success) {
        closeTerminationModal();
        fetchTicket();
      }
    }
  };

  const openCloseTicketModal = () => {
    setShowCloseTicketModal(true);
  };

  const closeTicketHandler = async (e) => {
    e.preventDefault();

    if (!resolution) {
      ToastUtil.error('Please enter resolution.');
      return false;
    }

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to close this ticket?'
      )
    ) {
      let api_path = `/tt/ticket/${ticket.id}/close_ticket`;
      let response = await newFetch(PUT, api_path, { resolution });

      ToastUtil.success(response.message);

      if (response.success) {
        setShowCloseTicketModal(false);
        setResolution('');
        fetchTicket();
      }
    }
  };

  return (
    <React.Fragment>
      <div style={{ paddingTop: '3rem', marginBottom: '6rem' }}>
        <div
          className="d-flex flex-column"
          style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
        >
          <NavLink
            to="/trouble-ticketing"
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div style={{ color: '#5156BE' }}>
              <i className="fas fa-chevron-left pe-2"></i>Back to Trouble
              Ticketing (TT)
            </div>
          </NavLink>
          <div className="d-flex justify-content-between pt-4">
            <h5>Ticket ID: {ticket ? ticket.ticket_id : ''}</h5>
            {type !== 'client' && ticket && ticket.status.id === 1 ? (
              <button
                className="btn btn-brand adjust-fs adjust-shadow"
                onClick={initiateProgressHandler}
              >
                Initiate In Progress
              </button>
            ) : type !== 'client' && ticket && ticket.status.id === 2 ? (
              <button
                className="btn btn-brand adjust-fs adjust-shadow"
                onClick={openCloseTicketModal}
                disabled={!ticket.action}
              >
                Close Ticket
              </button>
            ) : null}
            {/* <button className="btn btn-brand" onClick={openCloseTicketModal}>Close Ticket</button> */}
          </div>
        </div>
        <div
          className="d-flex"
          style={{ marginTop: '2rem', marginLeft: '3rem', marginRight: '3rem' }}
        >
          <div className="flex-grow-1">
            <div className="rounded shadow bg-white">
              {ticket && (
                <div className="p-4 d-flex flex-column">
                  <div className="d-flex flex-row border-bottom pb-4">
                    <div className="d-flex flex-column">
                      <div className="text-muted">Client</div>
                      <div className="text-brand fw-bold">
                        {client && client.name}
                      </div>
                    </div>
                    <div className="d-flex flex-column mx-4">
                      <div className="text-muted">Site</div>
                      <div className="text-brand fw-bold">
                        {ticket.site.name}
                      </div>
                    </div>
                    <div className="flex-grow-1"></div>
                    <div className="d-flex flex-column">
                      <div className="text-muted text-end">Date Created</div>
                      <div>
                        {moment(ticket.createdAt, 'YYYY-MM-DD HH:mm:ss').format(
                          'DD MMM YYYY, HH:mma'
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column pt-4">
                    <div className="text-muted">Title</div>
                    <p className="pt-2">{ticket.title}</p>
                    <div className="pt-4 text-muted">Description</div>
                    <p className="pt-2">{ticket.description}</p>

                    <div className="pt-4 text-muted">Attached File(s)</div>
                    <div className="pt-3">
                      <div className="row" style={{ maxWidth: '100%' }}>
                        {ticket.uploads &&
                          ticket.uploads.length > 0 &&
                          ticket.uploads.map((upload) => (
                            <div
                              key={upload.id}
                              className="col-3"
                              style={{ marginBottom: '30px' }}
                            >
                              <div
                                className="p-3 h-100 border rounded"
                                onClick={() =>
                                  window.open(
                                    `${SERVER_URL}/${upload.path}`,
                                    '_blank'
                                  )
                                }
                                style={{ cursor: 'pointer' }}
                              >
                                {upload.path.split('.').pop().toLowerCase() ===
                                  'jpg' ||
                                upload.path.split('.').pop().toLowerCase() ===
                                  'jpeg' ||
                                upload.path.split('.').pop().toLowerCase() ===
                                  'png' ? (
                                  <img
                                    src={`${SERVER_URL}/${upload.path}`}
                                    alt=""
                                    style={{ width: '100%' }}
                                  />
                                ) : upload.path
                                    .split('.')
                                    .pop()
                                    .toLowerCase() === 'pdf' ? (
                                  <SelfPDFViewer
                                    file={`${SERVER_URL}/${upload.path}`}
                                    withPageNum={false}
                                  />
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="mt-4">
              <strong className="mt-4">Activity Logs</strong>
            </div>
            <div className="rounded shadow bg-white mt-2 p-4">
              {ticket &&
                ticket.activity_logs.length > 0 &&
                ticket.activity_logs
                  .sort(
                    (a, b) =>
                      moment(b.createdAt, 'YYYY-MM-DD HH:mm:ss') -
                      moment(a.createdAt, 'YYYY-MM-DD HH:mm:ss')
                  )
                  .map((log) => (
                    <div key={log.id} className="d-flex flex-row py-1">
                      <div className="text-muted" style={{ width: '175px' }}>
                        {moment(log.createdAt, 'YYYY-MM-DD HH:mm:ss').format(
                          'DD MMM YYYY, HH:mma'
                        )}
                      </div>
                      <div className="flex-grow-1">{log.activity}</div>
                    </div>
                  ))}
            </div>
          </div>
          <div
            className="d-flex flex-column"
            style={{ minWidth: '250px', width: '250px', marginLeft: '2rem' }}
          >
            <strong>Status</strong>
            <div className="mt-2">
              <span
                className={
                  'badge text-bg-pill ' +
                  (ticket && ticket.status.id === 1
                    ? 'text-bg-warning'
                    : ticket && ticket.status.id === 2
                    ? 'text-bg-success'
                    : ticket && ticket.status.id === 3
                    ? 'text-bg-secondary'
                    : '')
                }
              >
                {ticket && ticket.status.name}
              </span>
            </div>

            <strong className="mt-4">Ticket Details</strong>

            <div className="text-muted mt-2">Incident</div>
            <div className="mt-2">{ticket ? ticket.incident.name : '-'}</div>
            <div className="text-muted mt-2">SEV Level</div>
            <div className="mt-2">
              {ticket ? ticket.incident.severity.name : '-'}
            </div>
            <div className="text-muted mt-2">TT Group(s)</div>
            <div className="mt-2">
              {ticket
                ? ticket.groups.map((group) => group.name).join(', ')
                : '-'}
            </div>

            <strong className="mt-4">Resolution</strong>
            <div className="mt-2">
              {ticket &&
                (ticket.resolution ? ticket.resolution : 'Not resolved')}
            </div>

            <strong className="mt-4">Action</strong>
            {type === 'client' ? (
              <React.Fragment>
                {ticket && !ticket.action_id
                  ? 'No action initiated'
                  : ticket && ticket.action.name}
              </React.Fragment>
            ) : (
              <select
                name="ttAction"
                id="ttAction"
                className="form-select mt-2 adjust-fs"
                disabled={ticket && ticket.status_id !== 2}
                value={selectedAction}
                onChange={(e) => selectActionHandler(e)}
              >
                {ticket && ticket.status_id !== 3 && !ticket.action_id && (
                  <option value="0">Select</option>
                )}
                {actions &&
                  actions.length > 0 &&
                  actions.map((action) => (
                    <option key={action.id} value={action.id}>
                      {action.name}
                    </option>
                  ))}
              </select>
            )}

            <strong className="mt-4 mb-2">Associate(s)</strong>
            {ticket &&
              ticket.associates.length > 0 &&
              ticket.associates.map((associate) => (
                <div
                  key={associate.id}
                  className="d-flex align-items-center my-1 py-1 rounded"
                  style={{ backgroundColor: '#f1f1f1', cursor: 'pointer' }}
                  onClick={() => openAssociateSidebar(associate.id)}
                >
                  <div className="mx-2">
                    <img
                      className="img-responsive rounded-circle border"
                      src={
                        associate.image
                          ? `${SERVER_URL}/${associate.image}`
                          : placeholderImage
                      }
                      alt="username-img"
                      style={{ height: '35px', width: '35px' }}
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center w-100">
                    <div>
                      {`${associate.first_name} ${associate.last_name}`.length >
                      18
                        ? `${associate.first_name} ${associate.last_name}`.substr(
                            0,
                            18
                          ) + '...'
                        : `${associate.first_name} ${associate.last_name}`}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      {associate && showSidebar && (
        <AssociateSidebar
          associate={associate}
          activeSidebar={showSidebar}
          setActiveSidebar={setShowSidebar}
        >
          {type !== 'client' && (
            <div className="w-100 d-flex justify-content-center">
              <button
                className="btn btn-brand adjust-fs adjust-shadow"
                onClick={openTerminationModal}
              >
                Terminate Associate
              </button>
            </div>
          )}
        </AssociateSidebar>
      )}
      <Modal showModal={showCloseTicketModal}>
        <form
          className="d-flex flex-column justify-content-between flex-grow-1 h-100"
          onSubmit={(e) => closeTicketHandler(e)}
        >
          <h6>Close Ticket</h6>
          <div className="mb-2" style={{ marginTop: '30px' }}>
            <label className="text-muted fw-bold" htmlFor="resolution">
              Resolution (Remark)
            </label>
            <textarea
              rows="10"
              className="form-control"
              id="resolution"
              placeholder="Enter resolution"
              value={resolution}
              onChange={(e) => setResolution(e.target.value)}
              style={{ resize: 'none' }}
            />
          </div>
          <div className="d-flex justify-content-end mt-auto pt-3 border-top">
            <button
              type="button"
              onClick={() => setShowCloseTicketModal(false)}
              className="btn btn-outline-brand adjust-fs adjust-shadow"
              style={{ width: '12rem' }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-brand ms-3 adjust-fs adjust-shadow"
              style={{ width: '12rem' }}
            >
              Confirm
            </button>
          </div>
        </form>
      </Modal>
      <Modal showModal={showTerminationModal}>
        <form
          className="d-flex flex-column justify-content-between flex-grow-1 h-100"
          onSubmit={(e) => terminationHandler(e)}
        >
          <h6>Immediate Termination</h6>
          <div className="d-flex flex-column">
            <label className="text-muted fw-bold">Selected Associate</label>
            {associate && (
              <div
                key={associate.id}
                className="d-flex align-items-center my-1 rounded"
              >
                <div className="mx-2">
                  <img
                    className="img-responsive rounded-circle border"
                    src={
                      associate.image
                        ? `${SERVER_URL}/${associate.image}`
                        : placeholderImage
                    }
                    alt="username-img"
                    style={{ height: '35px', width: '35px' }}
                  />
                </div>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div>{`${associate.first_name} ${associate.last_name}`}</div>
                </div>
              </div>
            )}
          </div>
          <div className="row mt-2">
            <div className="col-6">
              <div className="mb-2">
                <label className="text-muted fw-bold" htmlFor="incidents">
                  Select Incident
                </label>
                <select
                  name="incidents"
                  id="incidents"
                  className="form-select adjust-fs"
                  value={selectedIncident}
                  onChange={(e) =>
                    setSelectedIncident(parseInt(e.target.value))
                  }
                >
                  <option value="0">Select</option>
                  {incidents &&
                    incidents.length > 0 &&
                    incidents.map((incident) => (
                      <option key={incident.id} value={incident.id}>
                        {incident.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            <div className="col-6">
              <div className="mb-2">
                <label className="text-muted fw-bold" htmlFor="dateOfIncident">
                  Date of Incident
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="dateOfIncident"
                  value={dateOfIncident}
                  onChange={(e) => setDateOfIncident(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="mb-2">
            <label className="text-muted fw-bold" htmlFor="resolution">
              Remarks
            </label>
            <textarea
              rows="5"
              className="form-control"
              id="resolution"
              placeholder="Enter remarks"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              style={{ resize: 'none' }}
            />
          </div>
          <div className="d-flex justify-content-between mt-auto pt-3 border-top">
            <button
              type="button"
              onClick={() => setShowTerminationModal(false)}
              className="btn btn-outline-brand adjust-fs adjust-shadow"
              style={{ width: '10rem' }}
            >
              Cancel
            </button>
            <div className="d-flex justify-content-end">
              {associate && selectedIncident && dateOfIncident && (
                <button
                  type="button"
                  onClick={() => setShowTerminationLetterModal(true)}
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '10rem' }}
                >
                  Preview
                </button>
              )}
              <button
                type="submit"
                className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                style={{ width: '10rem' }}
              >
                Confirm
              </button>
            </div>
          </div>
        </form>
      </Modal>
      <Modal showModal={showTerminationLetterModal}>
        <div className="d-flex flex-column justify-content-between flex-grow-1 h-100">
          {associate && selectedIncident && dateOfIncident && (
            <PDFViewer style={{ height: '100%', width: '100%' }}>
              <ImmediateTermination
                associateName={`${associate.first_name} ${associate.last_name}`}
                incident={
                  incidents.find((incident) => incident.id === selectedIncident)
                    .name
                }
                dateOfIncident={moment(dateOfIncident, 'YYYY-MM-DD').format(
                  'DD MMMM YYYY'
                )}
                remarks={remarks}
              />
            </PDFViewer>
          )}

          <div className="d-flex justify-content-end mt-auto pt-3 border-top">
            <button
              type="button"
              onClick={() => setShowTerminationLetterModal(false)}
              className="btn btn-outline-brand adjust-fs adjust-shadow"
              style={{ width: '10rem' }}
            >
              Back
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(TTDetail);
